import { render, staticRenderFns } from "./InternetAccess.vue?vue&type=template&id=48b0895c&scoped=true"
import script from "./InternetAccess.vue?vue&type=script&lang=js"
export * from "./InternetAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b0895c",
  null
  
)

export default component.exports